import { __decorate } from "tslib";
import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import { accountRules } from '@/common/js/form-rule/index';
import { URLS } from '@/common/js/constant/index';
import Back from './common-back.vue';
let DrawerAddAccount = class DrawerAddAccount extends Vue {
    constructor() {
        super(...arguments);
        this.form = {
            login_type: 'email',
            username: '',
            password: '',
            confirm_password: '',
        };
        this.formRules = {};
        this.isLoading = false;
    }
    onShowChanged(val) {
        if (val) {
            this.bindRules();
        }
        else {
            const form = this.$refs.form;
            this.form.login_type = 'email';
            form.resetFields();
        }
    }
    bindRules() {
        this.formRules = accountRules.call(null, this.form);
    }
    /**
     * 登录类型发生改变
     * @param {String} val 当前类型
     */
    onLoginTypeChanged(val) {
        const form = this.$refs.form;
        this.form.login_type = val;
        form.resetFields();
    }
    save() {
        const form = this.$refs.form;
        form.validate((valid) => {
            if (valid) {
                this.isLoading = true;
                this.$ajax.post(URLS.createUser, {
                    login_type: this.form.login_type,
                    username: this.form.username,
                    password: KLOOK.md5(this.form.password),
                }).then((res) => {
                    this.$successTips();
                    this.isShowDrawer = false;
                    this.$emit('success');
                }).finally(() => {
                    this.isLoading = false;
                });
            }
        });
    }
};
__decorate([
    Prop({ type: Object, default: () => ({}) })
], DrawerAddAccount.prototype, "info", void 0);
__decorate([
    PropSync('show', { type: Boolean })
], DrawerAddAccount.prototype, "isShowDrawer", void 0);
__decorate([
    Watch('show')
], DrawerAddAccount.prototype, "onShowChanged", null);
DrawerAddAccount = __decorate([
    Component({
        components: {
            Back,
        },
    })
], DrawerAddAccount);
export default DrawerAddAccount;
